var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "7.9375mm",
    height: "10.583mm",
    viewBox: "0 0 7.9375 10.583333",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-195.6 -263.74)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.26458 0 0 .26458 575 419.13)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m-1434-587.31h30v40h-30z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -11.138)",
    strokeWidth: "1px",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    },
    "aria-label": "am"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-1432.2-555.51q0-0.40039 0.1465-0.74219 0.1563-0.35156 0.4102-0.61523 0.2636-0.26367 0.6152-0.41016 0.3516-0.15625 0.7422-0.15625h4.9609v-2.0117h-6.2793v-1.9238h6.2793q0.4004 0 0.752 0.15625 0.3515 0.14648 0.6054 0.41015 0.2637 0.25391 0.4102 0.60547 0.1563 0.35156 0.1563 0.75196v8.4766h-1.9239v-1.7578q-0.029 0.36132-0.1953 0.68359-0.166 0.32226-0.4297 0.56641-0.2539 0.23437-0.5859 0.37109t-0.7031 0.13672h-3.0469q-0.3906 0-0.7422-0.14649-0.3516-0.15625-0.6152-0.41015-0.2539-0.26367-0.4102-0.61524-0.1465-0.35156-0.1465-0.75195zm1.9141 2.6172h4.9609v-2.6172h-4.9609z",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-1412-559.44v8.4766h-1.9238v-8.4766h-4.4043v8.4766h-1.9141v-10.4h1.9141v1.8359q0.019-0.38085 0.1758-0.71289 0.1562-0.34179 0.4101-0.58593 0.2637-0.25391 0.6055-0.39063 0.3418-0.14648 0.7324-0.14648h2.4805q0.3808 0 0.7226 0.14648 0.3418 0.13672 0.6055 0.39063 0.2637 0.24414 0.4199 0.58593 0.166 0.33204 0.1758 0.71289 0.019-0.38085 0.166-0.71289 0.1563-0.34179 0.4102-0.58593 0.2636-0.25391 0.6054-0.39063 0.3418-0.14648 0.7325-0.14648h2.4804q0.4004 0 0.752 0.15625 0.3515 0.14648 0.6055 0.41015 0.2636 0.25391 0.4101 0.60547 0.1563 0.35156 0.1563 0.75196v8.4766h-1.9239v-8.4766z",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAm);
export default __webpack_public_path__ + "static/media/am.e6f484ab1720de0444198354eecfb0c4.svg";
export { ForwardRef as ReactComponent };